import React, { useState, useEffect } from "react";
import DataTable from "../../Common/DataTable/DataTable";
import { SubscriptionDetails } from "../../api";
import CustomSpinner from "../../Common/Spinner";

const subscriptionColumns = [
  {
    Header: "Plan Code",
    accessor: "planCode",
    search: false,
  },
  {
    Header: "Plan Name",
    accessor: "planName",
    search: false,
  },
  {
    Header: "Start Date",
    accessor: "subscriptionStartDate",
    search: false,
  },
  {
    Header: "Renewal Date",
    accessor: "subscriptionRenewalDate",
    search: false,
  },
  {
    Header: "Status",
    accessor: "status",
    search: false,
  },
];

const Subscription = ({ custId }) => {
  const [dataLoading, setDataLoading] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const fetchSubscriptionDetails = async () => {
    try {
      setDataLoading(true);
      const response = await SubscriptionDetails(custId);
      if (response?.code === 200) {
        const formattedData = response?.data?.map((sub) => ({
          planCode: sub?.planCode || "--",
          planName: sub?.planName || "--",
          subscriptionStartDate: sub?.subscriptionStartDate || "--",
          subscriptionRenewalDate: sub?.subscriptionRenewalDate || "--",
          status: sub?.status || "--",
        }));
        setSubscriptionData(formattedData);
        setErrorMessage(null);
      } else {
        setErrorMessage(response?.data?.message || "Failed to fetch subscription details");
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Something went wrong");
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionDetails();
  }, [custId]);

  if (dataLoading) {
    return <CustomSpinner />;
  }

  if (errorMessage) {
    return <div style={{ color: "red" }}>{errorMessage}</div>;
  }

  return (
    <div style={{ marginTop: "30px" }}>
      <DataTable
        columns={subscriptionColumns}
        list={subscriptionData}
        rowClick={false}
      />
    </div>
  );
};

export default Subscription;